import LoadingIndicator from '../../../../commons/src/components/loading-indicator'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

interface Props {
  message: string
}

const LoadingModal = ({message}: Props) => (
  <Modal>
    <div className="u-align-center">
      <Paragraph>
        <LoadingIndicator />
      </Paragraph>
      <Paragraph>{message}</Paragraph>
    </div>
  </Modal>
)

export default LoadingModal
